/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/match.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Use `MATCH` to perform a match query on the specified field or expression.\nUsing `MATCH` is equivalent to using the `match` query in the Elasticsearch Query DSL.',
  examples: [
    'FROM books\n| WHERE MATCH(author, "Faulkner")',
    'FROM books\n| WHERE MATCH(title, "Hobbit Back Again", {"operator": "AND"})\n| KEEP title;',
  ],
  params: {
    field: 'Field or expression that the query will target.',
    query: 'Value to find in the provided field or expression.',
    options: '(Optional) Match additional options as <<esql-function-named-params,function named parameters>>.',
  },
};

export default docs;
